export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}scorm/scorm-submission`;

    return $resource(url, null, {
        get: {
            method: 'GET',
            url: `${url}/:guid`
        },
        start: {
            method: 'GET',
            url: `${url}/start/:guid`
        },
        update: {
            method: 'PUT',
            url: `${url}/update/:guid`
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/ScormSubmission/index.js